import Route from './route';
import { LazyloadWrapper } from '../../Components/Common';

const PackageAlerts = LazyloadWrapper(import('./PackageAlerts'));

export default {
  RenderProp: PackageAlerts,
  mainRoute: Route,
};
